import React, { PureComponent } from 'react';
import Video from '../wrapper/Video';
import '../styles/modal.css'; // Reuse the same modal CSS

class VideoComponent extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            source: "",
            display: "none",
            loading: true,
            css: props.CSSModules["VideoComponent"],
            activeButton: ''
        };

        this.videoRef = React.createRef();
    }

    componentDidMount() {
        this.setVideoData();
        this.lastVideoTime = -1;
        this.idleInterval = setInterval(() => {
            // Only keep the kiosk awake while the video is actually making playback
            // progress — a stalled, failed, or paused video must not block the idle
            // reset forever. A network-stalled video reports paused=false, so compare
            // currentTime against the previous tick instead of relying on flags.
            const video = this.videoRef.current;
            const progressed = video && !video.paused && !video.ended && video.currentTime !== this.lastVideoTime;
            if (video) {
                this.lastVideoTime = video.currentTime;
            }
            if (progressed) {
                this.props.navEvents('idleTimer', '');
            }
        }, 2000);
    }

    componentWillUnmount() {
        clearInterval(this.idleInterval);
    }

    setVideoData = () => {
        if (this.props.source && this.props.source !== '') {
            this.setState({
                source: this.props.source,
                display: "",
            });
        } else {
            this.setState({
                display: "none",
            });
        }
    }

    handleClose = () => {
        if (this.props.handleClose) {
            this.props.handleClose('video');
        }
    }

    handleDown = (buttonId) => {
        this.setState({
            activeButton: buttonId
        });
    }

    handleUp = () => {
        this.setState({
            activeButton: ''
        });
    }

    render() {
        let css = this.state.css;

        let customClasses = '';
        if (this.props.custom_classes && this.props.custom_classes.length > 0) {
            this.props.custom_classes.forEach((element) => {
                if ((/^([a-z_]|-[a-z_-])[a-z\d_-]*$/i).test(element)) {
                    customClasses += ` ${element}`;
                }
            });
        }

        return (
            <div ref={this.props.domRef} className={`modal-main ${customClasses}`.trim()} style={{ display: this.state.display }}>
                {this.state.loading && (
                    <div className="loading">Loading...</div>
                )}
                <Video
                    ref={this.videoRef}
                    className={css?.videoContainer}
                    src={this.state.source}
                    autoPlay={true}
                    preload="auto"
                    onLoadedData={() => this.setState({ loading: false })}
                    onEnded={() => this.props.handleClose('video')}
                >
                    Your browser does not support the video tag.
                </Video>
                <div className={`videoUi ${css?.videoUi}`}>
                    <button
                        className={`modalButton videoButtonClose ${css?.navBtn} ${this.state.activeButton === 'close' ? css?.activeButton : ''}`}
                        type="button"
                        onMouseDown={() => this.handleDown('close')}
                        onMouseUp={this.handleUp}
                        onMouseLeave={this.handleUp}
                        onTouchStart={() => this.handleDown('close')}
                        onTouchEnd={this.handleUp}
                        onPointerDown={() => this.handleDown('close')}
                        onPointerUp={this.handleUp}
                        onPointerLeave={this.handleUp}
                        onClick={this.handleClose}
                    >
                        Close
                    </button>
                </div>
            </div>
        );
    }
}

export default VideoComponent;